import { NOTICE_THEME_VARS, TTS_TEXT_ATTRIBUTE } from "./constants";
import type { NoticeAppearanceColors } from "./types";

/**
 * The talkback highlight the console set, as the custom properties the
 * injected highlight rules read. Empty when the admin set none, so the rules
 * fall back to the default highlight every platform draws.
 */
export const buildTtsCssVariables = (
  colors: NoticeAppearanceColors,
): Record<string, string> =>
  Object.fromEntries(
    [
      [NOTICE_THEME_VARS.ttsBackground, colors.tts_highlight_bg],
      [NOTICE_THEME_VARS.ttsText, colors.tts_highlight_text],
    ].filter((entry): entry is [string, string] => entry[1] !== undefined),
  );

/** Switches on the highlight text rule, which classic leaves off entirely. */
export const buildTtsRootAttributes = (
  colors: NoticeAppearanceColors,
): Readonly<Record<string, string>> =>
  colors.tts_highlight_text ? { [TTS_TEXT_ATTRIBUTE]: "" } : {};
